"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function MedicinaCapilarDeAltoNivel() {
  const headlineWords = [{
    text: "Medicina",
    italic: false
  }, {
    text: "capilar",
    italic: true
  }, {
    text: "de",
    italic: false
  }, {
    text: "alto",
    italic: false
  }, {
    text: "nivel",
    italic: false
  }];
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.1
  });
  const {
    ref: paragraphRef,
    isVisible: paragraphVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.1
  });
  const {
    ref: buttonsRef,
    isVisible: buttonsVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: scrollRef,
    isVisible: scrollVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="3781" id="medicina-capilar-de-alto-nivel" className="relative w-full overflow-hidden text-foreground bg-muted">
      <div className="relative mx-auto max-w-[1440px] px-6 pt-12 pb-24 md:px-12 md:pt-20 md:pb-32 lg:pt-20 lg:pb-40">
        {}
        <div ref={scrollRef} className="absolute left-4 bottom-12 hidden lg:flex items-center" style={{
        opacity: scrollVisible ? 1 : 0,
        transform: scrollVisible ? "translateY(0)" : "translateY(24px)",
        transition: "opacity 800ms ease-out 600ms, transform 800ms ease-out 600ms"
      }}>
          
        </div>

        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-8">
          {}
          <div className="!m-0 ![padding:15px_0px_0px_0px] lg:col-span-5 lg:col-start-1">
            <div ref={imageRef} className="relative" style={{
            opacity: imageVisible ? 1 : 0,
            transform: imageVisible ? "scale(1)" : "scale(0.96)",
            transition: "opacity 1200ms ease-out, transform 1200ms ease-out"
          }}>
              {}
              <div className="absolute -inset-8 -z-10 opacity-70" style={{
              background: "radial-gradient(closest-side, hsla(38, 48%, 61%, 0.35), transparent 80%)"
            }} />
              <div className="overflow-hidden shadow-lg">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/clinica_capilar_dra_soto.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/clinica_capilar_dra_soto.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/clinica_capilar_dra_soto.webp-wvc-sizes" alt="Dra. María del Carmen Soto en consulta clínica de alta precisión" loading="lazy" decoding="async" className="block h-auto w-full object-cover" style={{
                aspectRatio: "4 / 5"
              }} src="https://msinstitutocapilar.com/wp-content/uploads/2026/07/WhatsApp-Image-2026-06-27-at-10.50.26-2.jpeg" />
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-6 lg:col-start-7">
            {}
            <div ref={eyebrowRef} style={{
            opacity: eyebrowVisible ? 1 : 0,
            transform: eyebrowVisible ? "translateY(0)" : "translateY(16px)",
            transition: "opacity 700ms ease-out, transform 700ms ease-out"
          }}>
              
            </div>

            {}
            <h1 ref={headlineRef} className="font-default mt-6 text-foreground" style={{
            fontSize: "clamp(2.75rem, 8vw, 8rem)",
            lineHeight: "0.95",
            letterSpacing: "-0.03em",
            fontWeight: 500
          }}>
              <span className="block">
                {headlineWords.slice(0, 2).map((word, i) => <span key={i} data-index={i} className="inline-block overflow-hidden align-bottom">
                    <span className="inline-block !text-[75px]" style={{
                  opacity: headlineVisible ? 1 : 0,
                  transform: headlineVisible ? "translateY(0)" : "translateY(24px)",
                  transition: `opacity 800ms ease-out ${i * 80}ms, transform 800ms ease-out ${i * 80}ms`,
                  color: word.italic ? "var(--primary)" : "var(--foreground)",
                  fontStyle: word.italic ? "italic" : "normal",
                  marginRight: "0.25em"
                }}>
                      {word.text}
                    </span>
                  </span>)}
              </span>
              <span className="block">
                {headlineWords.slice(2).map((word, i) => {
                const idx = i + 2;
                return <span key={idx} data-index={idx} className="inline-block overflow-hidden align-bottom">
                      <span className="inline-block !text-[75px] ![margin:0px_15px_0px_0px]" style={{
                    opacity: headlineVisible ? 1 : 0,
                    transform: headlineVisible ? "translateY(0)" : "translateY(24px)",
                    transition: `opacity 800ms ease-out ${idx * 80}ms, transform 800ms ease-out ${idx * 80}ms`,
                    color: word.italic ? "var(--primary)" : "var(--foreground)",
                    fontStyle: word.italic ? "italic" : "normal",
                    marginRight: "0.25em"
                  }}>
                        {word.text}
                      </span>
                    </span>;
              })}
              </span>
            </h1>

            {}
            <div className="mt-10 ![padding:0px_40px_0px_0px]">
              <p ref={paragraphRef} className="font-default text-lg leading-relaxed text-secondary md:text-xl" style={{
              opacity: paragraphVisible ? 1 : 0,
              transform: paragraphVisible ? "translateY(0)" : "translateY(16px)",
              transition: "opacity 900ms ease-out 400ms, transform 900ms ease-out 400ms"
            }}>Recuperamos la salud de tu cabello con técnicas avanzadas, garantizando resultados naturales y un seguimiento humano en cada etapa de tu tratamiento.</p>
            </div>

            {}
            <div ref={buttonsRef} className="mt-10 flex flex-col gap-4 !p-0 sm:flex-row sm:items-center" style={{
            opacity: buttonsVisible ? 1 : 0,
            transform: buttonsVisible ? "translateY(0)" : "translateY(16px)",
            transition: "opacity 900ms ease-out 600ms, transform 900ms ease-out 600ms"
          }}>
              <Button asChild size="lg" className="font-default h-14 bg-primary px-8 text-base text-primary-foreground hover:bg-secondary">
                <Link href="https://​https://msinstitutocapilar.com/contacto/" newTab>Solicitar Consulta</Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="font-default h-14 border-primary bg-transparent px-8 text-base text-primary hover:bg-primary hover:text-white">
                <Link href="https://​https://msinstitutocapilar.com/casos-de-exito/" newTab>Ver Casos de éxito</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}